import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Dialog, ERC721Contract, ERC721ContractList, Icon, Input, LoadingIcon, } from '@/components';
import { useERC721ContractList, useGetERC721Contract } from '@/hooks';
import { getStorage, isSameAddress, setStorage, StorageKeys, useBoolean } from '@/utils';
import classnames from 'classnames';
import { utils } from 'ethers';
import { useEffect, useMemo, useState } from 'react';
import { useLocales } from '../useLocales';
import styles from './index.module.less';
function storeNewToken(newToken) {
    const contracts = getStorage(StorageKeys.ERC721Contracts);
    setStorage(StorageKeys.ERC721Contracts, contracts ? [...contracts, newToken] : [newToken]);
}
export const ERC721ContractPicker = ({ onPick, ...rest }) => {
    const t = useLocales();
    const { erc721Contracts, updateERC721Contracts } = useERC721ContractList();
    const [keyword, setKeyword] = useState('');
    const getERC721Contract = useGetERC721Contract();
    const [newContract, setNewContract] = useState(null);
    const filteredContracts = useMemo(() => {
        const kw = keyword.toLowerCase();
        return erc721Contracts.filter((token) => {
            const { symbol, name, address } = token;
            return (symbol.toLowerCase().includes(kw) ||
                name.toLowerCase().includes(kw) ||
                address.toLowerCase().startsWith(kw));
        });
    }, [keyword, erc721Contracts]);
    const isNewAddress = useMemo(() => {
        return (utils.isAddress(keyword) &&
            erc721Contracts.findIndex((token) => isSameAddress(token.address, keyword)) === -1);
    }, [keyword, erc721Contracts]);
    const [checking, startChecking, finishChecking] = useBoolean();
    useEffect(() => {
        if (isNewAddress) {
            startChecking();
            getERC721Contract(keyword).then(setNewContract).finally(finishChecking);
        }
    }, [isNewAddress, keyword, getERC721Contract]);
    let content;
    if (isNewAddress) {
        if (checking)
            content = _jsx(LoadingIcon, { size: 18 });
        if (newContract) {
            content = (_jsx("div", { className: classnames(styles.tokenList, styles.newList), children: _jsxs("div", { className: styles.row, children: [_jsx(ERC721Contract, { className: styles.token, token: newContract, hideBalance: true }), _jsx(Button, { size: "small", colorScheme: "primary", onClick: () => {
                                storeNewToken(newContract);
                                setKeyword('');
                                updateERC721Contracts();
                            }, children: t('Import') })] }) }));
        }
        else {
            content = (_jsx("div", { className: styles.noResult, children: t('The contract address is incorrect or does not exist') }));
        }
    }
    else if (keyword && filteredContracts.length === 0) {
        content = (_jsxs("div", { className: styles.noResult, children: [t('No results for'), " ", _jsx("strong", { className: styles.keyword, children: keyword })] }));
    }
    else {
        content = (_jsx(ERC721ContractList, { className: styles.tokenList, contracts: filteredContracts, onPick: onPick }));
    }
    return (_jsxs(Dialog, { className: styles.dialog, title: t('Seletct a Collection'), ...rest, children: [_jsx("div", { className: styles.searchGroup, children: _jsx(Input, { fullWidth: true, round: true, className: styles.input, value: keyword, spellCheck: false, onChange: (evt) => setKeyword(evt.currentTarget.value), placeholder: t('Search name or paste address'), leftAddon: _jsx(Icon, { type: "search", size: 24 }) }) }), content] }));
};
